import React from 'react'

function InplayTodayTomorrowTabs({activeTab, setActiveTab}) {
  return (
    <div className="flex flex-row justify-start items-center px-2 py-1">
    <div className="flex flex-row min-h-10 w-full bg-white max-w-[720px] rounded-md border shadow-md">
        <div 
            className={`${activeTab==="Inplay"? "bg-gray2 text-white shadow-sm": "bg-white text-gray2"} flex flex-row w-1/3 min-h-10 justify-center items-center rounded-tl-md rounded-bl-md border-r font-semibold text-sm`}
            onClick={()=> {if(setActiveTab){ setActiveTab("Inplay")}}}
        >
            
            Inplay
        </div>
        <div 
        className={`${activeTab==="Today"? "bg-gray2 text-white shadow-sm": "bg-white text-gray2"} flex flex-row w-1/3 min-h-10 justify-center items-center border-r font-semibold text-sm`}
        onClick={()=> {if(setActiveTab){ setActiveTab("Today")}}}

        >
            Today
        </div>
        <div 
        className={`${activeTab==="Tomorrow"? "bg-gray2 text-white shadow-sm": "bg-white text-gray2"} flex flex-row w-1/3 min-h-10 justify-center items-center rounded-tr-md rounded-br-md font-semibold text-sm`}
        onClick={()=> {if(setActiveTab){ setActiveTab("Tomorrow")}}}

        >
            Tomorrow
        </div>
    </div>
</div>  )
}

export default InplayTodayTomorrowTabs